import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ContactForm from "./components/ContactForm";
import './i18n';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:lang/:freightId?" element={<ContactForm />} />
        <Route path="/:freightId?" element={<ContactForm />} />
      </Routes>
    </Router>
  );
}

export default App;
